export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/45b3d9bead8ca49501a2a3b80e7cc1ac.png";